import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Sync = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25 8.33337V2.08337L16.6667 10.4167L25 18.75V12.5C31.8959 12.5 37.5 18.1042 37.5 25C37.5 27.1042 36.9792 29.1042 36.0417 30.8334L39.0834 33.875C40.7084 31.3125 41.6667 28.2709 41.6667 25C41.6667 15.7917 34.2084 8.33337 25 8.33337ZM25 37.5C18.1042 37.5 12.5 31.8959 12.5 25C12.5 22.8959 13.0209 20.8959 13.9584 19.1667L10.9167 16.125C9.29171 18.6875 8.33337 21.7292 8.33337 25C8.33337 34.2084 15.7917 41.6667 25 41.6667V47.9167L33.3334 39.5834L25 31.25V37.5Z"
        fill={color}
      />
    </svg>
  )
}
